// extracted by mini-css-extract-plugin
module.exports = {"card":"VerifyEmailSuccess_card__3ujZ7","description":"VerifyEmailSuccess_description__3xLyn"};